import { useEffect } from 'react';
import { useMutation } from 'react-apollo';
import { useSelector } from 'react-redux';

import { HierarchyViewsCreate } from '../../../../graphql/mutations/hierarchy-groups';

const useHierarchyViewsCreate = ({ recordId }) => {
  const authenticated = useSelector(({ auth }) => auth.authenticated);
  const [hierarchyViewsCreate] = useMutation(HierarchyViewsCreate);

  useEffect(() => {
    if (recordId && authenticated) {
      try {
        hierarchyViewsCreate({
          variables: {
            input: {
              hierarchy_item_ids: [recordId],
              platform: 'WEB',
            },
          },
        });
      } catch {
        // Do nothing really, we don't mind this too much.
      }
    }
  }, [recordId, authenticated]);
};

export default useHierarchyViewsCreate;
